export default [
    'uploadCargaARRequestStatus',
];
